import * as actionTypes from './actionTypes';
import axios, { AxiosResponse } from 'axios';

const API_HOST_URL = process.env.REACT_APP_API_URL //'http://127.0.0.1:8000'

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    }
}

export const authSuccess = (token: any, user: any) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        token: token,
        currentUser: user
    }
}

export const authFail = (error: any) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    }
}

export const logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('expirationDate'); 

    return {
        type: actionTypes.AUTH_LOGOUT
    }
}

export const loggedInEmployee = (employee: any) => {
    return {
        type: actionTypes.FETCH_LOGGEDIN_EMPLOYEE,
        loggedInEmployee: employee
    }
}

export const userWithPermissionsData = (user: any) => {
    return {
        type: actionTypes.FETCH_USER_WITH_PERMISSIONS_DATA,
        userWithPermissionsData: user
    }
}

export const changeHeaderTitle = (title: any) => {
    return {
        type: actionTypes.CHANGE_HEADER_TITLE,
        headerTitle: title
    }
}

export const loadUserPermissions = (permissions: any, groups: any, content_types: any) => {
    return {
        type: actionTypes.LOAD_USER_PERMISSIONS,
        userPermissions: permissions,
        userGroups: groups,
        userContentTypes: content_types
    }
}


export const checkAuthTimeout = (expirationTime: any) => {
    return (dispatch: any) => {
        setTimeout(() => {
            dispatch(logout())
        }, expirationTime * 1000)
    }
}

export const loggedInUserInfo = (token: any, dispatch: any) =>{
    let loggedInUser: any;

        axios.get(`${API_HOST_URL}/rest-auth/user/`, {
            headers: {Authorization: 'Token ' + token}  
        })
        .then(res => {
            loggedInUser =  res.data;
            console.log("LoggedIn User Info: ", loggedInUser)
            
            window.localStorage.setItem("currentUser", JSON.stringify(loggedInUser));
            dispatch(authSuccess(token, loggedInUser)) 
            dispatch(fetchUserWithPermissionsData(loggedInUser.pk))
            dispatch(fetchLoggedInEmployee(loggedInUser.pk)) 
        })
        .catch(err => {
            console.log(err);
        })
}

export const authLogin = (username: any, password: any) => {
    return (dispatch: any) => {
        dispatch(authStart());
        axios.post(`${API_HOST_URL}/rest-auth/login/`, {
            username: username,
            password: password
        })
        .then(res => {
            const token = res.data.key;
            const expirationDate = new Date(new Date().getTime() * 3600 * 1000);

            window.localStorage.setItem('token', token);
            window.localStorage.setItem('expirationDate', expirationDate.toDateString());
            //LoggedIn User Info    
            loggedInUserInfo(token, dispatch)
            // dispatch(fetchLoggedInEmployee(userId)) 
            dispatch(checkAuthTimeout(3600))
        })
        .catch(err => {
            dispatch(authFail(err))
        })
    }
}

export const authSignup = (username: any, email: any, password1: any, password2: any) => {
    return (dispatch: any) => {
        dispatch(authStart());
        axios.post(`${API_HOST_URL}/rest-auth/registration/`, {
            username: username,
            email: email,
            password1: password1,
            password2: password2
        })
        .then(res => {
            const token = res.data.key ;
            const currentUser = res.data;
            const expirationDate = new Date(new Date().getTime() * 3600 * 1000);
            localStorage.setItem('token', token);
            localStorage.setItem('expirationDate', expirationDate.toDateString());
            dispatch(authSuccess(token, currentUser))
            dispatch(checkAuthTimeout(3600))
            console.log("data",res.data);
        })
        .catch(err => {
            dispatch(authFail(err))
        })
    }
}
export const authCheckState = () => {
    return (dispatch: any) => {
        const token = window.localStorage.getItem('token');
        if(token === undefined){
            dispatch(logout());
        } else {
            const expirationDateString: any = window.localStorage.getItem('expirationDate');
            const expirationDate = new Date(parseInt(expirationDateString));
            if (expirationDate <= new Date()){
                dispatch(logout())
            } else {
                const currentUser = window.localStorage.getItem("currentUser");
                dispatch(authSuccess(token, currentUser));
                dispatch(checkAuthTimeout( (expirationDate.getTime() - new Date().getTime()) / 1000 ));
            }
        }
    }
}

export const fetchLoggedInEmployee =(userId: any) => {
    return (dispatch: any) => {
        axios.get(`${API_HOST_URL}/api/employee/employee/?expand=department&user=${userId}`)
        .then(res => {
            console.log("LoggedInEmployee:", res.data[0]);
            dispatch(loggedInEmployee(res.data[0]))
        })
        .catch(err => {
            // dispatch(authFail(err))
        })
    }
}

export const fetchUserWithPermissionsData = (userId: any) => {
    return (dispatch: any) => {
        axios.get(`${API_HOST_URL}/api/systemsetup/user/${userId}`)
        .then(res => {
            console.log("User With Permissions Data:", res.data);
            dispatch(userWithPermissionsData(res.data));
            dispatch(fetchGroupsAndPermissionsForLoggedInUser(res.data));
        })
        .catch(err => {
            // dispatch(authFail(err))
        })
    }
}

export const fetchGroupsAndPermissionsForLoggedInUser = (user: any) => {
    return async (dispatch: any) => { 
        let all_groups: any[] = [];
        let user_groups = user.groups;
        let user_group_names: any[] = [];

        let all_permissions: any[] = [];
        let user_permissions = user.user_permissions;
        let user_permission_names: any[] = [];
        
        let all_user_permissions_with_possible_duplicates: any[] = [];
        let all_user_permissions_with_no_duplicates = [];

        let all_contenttypes: any[] = [];
        let user_content_types_ids_with_duplicates: any[] = [];
        let user_content_types_ids_with_no_duplicates = [];
        let user_content_types_names_with_possible_duplicates: any[] = [];
        let user_content_types_names_with_no_duplicates = [];

        all_permissions = await fetchAllPermissions();
        console.log("All Permissions: ", all_permissions);
        all_contenttypes = await fetchAllContentTypes();
        console.log("All Content Types: ", all_contenttypes);

        axios.get(`${API_HOST_URL}/api/systemsetup/group/`)
        .then(res => {
            all_groups = res.data
            console.log("All Groups:", all_groups);
            console.log("User Groups: ", user_groups);

            // if(user_groups)
            user_groups.forEach( (user_group_id: any) => {
                //User groups are ids, so use the ids to get the names
                all_groups.forEach( (group) => {
                    if(user_group_id == group.id){
                        user_group_names.push(group.name)

                        //Extract permissions for the user group
                        all_user_permissions_with_possible_duplicates.push(...group.permissions)
                    } 
                });

            });

            //get permissions for the user.
            user_permissions.forEach( (permission_id: any) => {
                console.log("User permission: ", permission_id);
                all_user_permissions_with_possible_duplicates.push(permission_id)
            });
            
            all_user_permissions_with_no_duplicates  = [...new Set(all_user_permissions_with_possible_duplicates)];
            console.log("all_user_permissions_ids: ", all_user_permissions_with_no_duplicates);

            //get permission names for all the compiled permissions
            all_user_permissions_with_no_duplicates.forEach((user_permission_id) => {
                all_permissions.forEach((permission) => {
                    if(user_permission_id == permission.id){
                        user_permission_names.push(permission.codename)
                        //get content type
                        user_content_types_ids_with_duplicates.push(permission.content_type)

                    }
                })
            })

            user_content_types_ids_with_no_duplicates  = [...new Set(user_content_types_ids_with_duplicates)];
            console.log("user content_types ids: ", user_content_types_ids_with_no_duplicates)

            
            //get content type names for all the compiled content types
            user_content_types_ids_with_no_duplicates.forEach((content_type_id) => {
                all_contenttypes.forEach((content_type) => {
                    if(content_type_id == content_type.id){

                        user_content_types_names_with_possible_duplicates.push(content_type.app_label)

                    }
                })
            })

            user_content_types_names_with_no_duplicates  = [...new Set(user_content_types_names_with_possible_duplicates)];
            
            console.log("User group names: ", user_group_names);
            console.log("all_user_permission_names: ", user_permission_names);
            console.log("user_content_types_names: ", user_content_types_names_with_no_duplicates);
            

            dispatch(loadUserPermissions(user_permission_names, user_group_names, user_content_types_names_with_no_duplicates));
        })
        .catch(err => {
            // dispatch(authFail(err))
        })
    }
}

export const fetchAllPermissions = async() => {
    let all_permissions: any[] = [];
    await axios.get(`${API_HOST_URL}/api/systemsetup/permission/`)
        .then((res: AxiosResponse<any>) => {
            all_permissions.push(...res.data);
        })
        .catch(err => {
        })
        return all_permissions;
}

export const fetchAllContentTypes = async() => {
    let all_contenttypes: any[] = [];
    await axios.get(`${API_HOST_URL}/api/systemsetup/contenttype/`)
        .then((res: AxiosResponse<any>) => {
            all_contenttypes.push(...res.data);
        })
        .catch(err => {
        })
        return all_contenttypes;
}